import { AbLoads } from "../../Viewer/LoadExam/AbLoads";
import { showPrint } from "../../Viewer/Printer/Print";
import { TestPrinter } from "../../Viewer/Printer/TestPrinter";


export function loadPrinter(){
    AbLoads();
    showPrint();

    new TestPrinter()
}